// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_xFk","rootNoMargin":"styles_rootNoMargin__sGeQS"};